import { motion } from "framer-motion";
import { Send } from "lucide-react";
import { useSiteLang } from "../lib/siteLang";
import { StoreButtons } from "./StoreButtons";

export const Contact = () => {
  const { t } = useSiteLang();

  return (
    <>
      {/* Download */}
      <section id="download" className="section-padding bg-[#09101F]" data-testid="download-section">
        <div className="max-w-6xl mx-auto px-5 md:px-10">
          <motion.div
            initial={{ y: 28 }}
            whileInView={{ y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            className="relative overflow-hidden rounded-[2rem] border border-white/10"
          >
            <img src="/images/photo-conca.webp" alt="" className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
            <div className="absolute inset-0 hero-gradient" />
            <div className="relative px-6 py-14 md:px-16 md:py-20 text-center">
              <p className="section-label mb-4" data-testid="download-label">{t.downloadLabel}</p>
              <h2 className="font-tagline text-4xl md:text-6xl text-white mb-4" style={{ textWrap: "balance" }} data-testid="download-title">
                {t.downloadTitle}
              </h2>
              <p className="text-white/80 text-lg mb-9">{t.downloadText}</p>
              <StoreButtons className="justify-center" />
            </div>
          </motion.div>
        </div>
      </section>

      {/* Contact */}
      <section id="contact" className="pb-20 md:pb-28 bg-[#09101F]" data-testid="contact-section">
        <div className="max-w-3xl mx-auto px-5 md:px-10">
          <div className="app-card inner-glow p-8 md:p-12 text-center">
            <p className="section-label mb-4" data-testid="contact-label">{t.contactLabel}</p>
            <h2 className="text-3xl md:text-4xl text-white mb-4" data-testid="contact-title" style={{ textWrap: "balance" }}>{t.contactTitle}</h2>
            <p className="text-lg mb-8" style={{ color: "rgba(255,255,255,0.72)" }} data-testid="contact-description">{t.contactText}</p>

            <a href="mailto:gozzoguide@gmail.com" className="inline-flex items-center gap-3 btn-primary text-base md:text-lg px-8 py-4 orange-glow" data-testid="contact-email-btn">
              <Send className="w-5 h-5" aria-hidden="true" />
              <span>gozzoguide@gmail.com</span>
            </a>

            <div className="mt-10 pt-8 border-t border-white/10">
              <p className="text-sm tracking-[0.2em] uppercase mb-5 text-white/70" data-testid="follow-label">{t.follow}</p>
              <div className="flex items-center justify-center gap-4" data-testid="social-icons">
                <a
                  href="https://www.facebook.com/share/1AwpeoZ2xk/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                  data-testid="contact-facebook-link"
                  className="w-12 h-12 rounded-2xl bg-white/[0.06] border border-white/15 flex items-center justify-center transition-colors hover:bg-[#1877F2] hover:border-[#1877F2]"
                >
                  <svg viewBox="0 0 24 24" className="w-6 h-6 fill-white" aria-hidden="true">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12S0 5.446 0 12.073C0 18.062 4.388 23.027 10.125 23.928V15.54H7.078v-3.467h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953h-1.514c-1.491 0-1.955.925-1.955 1.874v2.25h3.328l-.532 3.467h-2.796v8.388C19.612 23.027 24 18.062 24 12.073z" />
                  </svg>
                </a>
                <a
                  href="https://www.instagram.com/gozzoguide/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                  data-testid="contact-instagram-link"
                  className="w-12 h-12 rounded-2xl bg-white/[0.06] border border-white/15 flex items-center justify-center transition-colors hover:bg-[#E1306C] hover:border-[#E1306C]"
                >
                  <svg viewBox="0 0 24 24" className="w-6 h-6 fill-none stroke-white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <rect x="3" y="3" width="18" height="18" rx="5" />
                    <circle cx="12" cy="12" r="4" />
                    <circle cx="17.5" cy="6.5" r="1.2" className="fill-white stroke-none" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
